// DevHub CUSTOM — i18n "kit" namespace: user-facing strings for the shared UI kit
// (components/common/*). Loading/empty/error states, the filter bar, card star
// toggle, and the range selector. See ./common.ts for the convention.
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const kitMessages = createTranslationRef({
  id: 'devhub.kit',
  messages: {
    // Loading / empty / error state blocks (states/*).
    states: {
      loading: 'Loading…',
      emptyTitle: 'Nothing to show',
      emptyBody: 'There is nothing here yet.',
      errorTitle: 'Something went wrong',
    },
    // FilterBar search + clear.
    filter: {
      searchPlaceholder: 'Search…',
      clear: 'Clear',
    },
    // EntityCard / StarToggle.
    card: {
      star: 'Star',
      unstar: 'Unstar',
      open: 'Open',
    },
  },
  translations: {
    de: () => import('./de/kit'),
  },
});
